export const HEAD_HEIGHT = 60;

export const FOOTER_HEIGHT = 80;

// TODO this is mock
export const phoneNumbers = [
  '(050) 000 00 00',
  '(050) 111 00 01',
  '(050) 222 00 02',
];

export const SLIDER_ID = 'sliderWithGallery';

export const GALLERY_ROOT_STYLES = {
  height: 'calc(100dvh - 60px - 80px)',
  top: 60,
  zIndex: 10100,
};
